import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import {NewSolutionCardComponent} from './new-solution-card.component';
import {PipesModule} from 'src/app/pipes/pipes.module';
import {RouterModule} from '@angular/router';
import {IconsModule} from './../../../icons/icons.module';

@NgModule({
  declarations: [
    NewSolutionCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    PipesModule,
    RouterModule,
    IconsModule
  ],
  exports: [
    NewSolutionCardComponent,
  ]
})
export class NewSolutionCardModule {
}
